<template>
  <h3 v-if="isValid"><i class="fa-solid fa-clock"/>Las entradas Anticipadas sólo permiten el ingreso hasta el {{ validUntilDisplay }} <strong>2:30 AM.</strong></h3>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getLongDayAndMonth } from '~/utils/DateHelper'

const props = defineProps<{
  startsAt: string | undefined
}>()

const isValid = computed(() => !!props.startsAt)

const validUntilDisplay = computed(() => {
  if (!props.startsAt) return ''

  const date = new Date(props.startsAt)
  // Add 1 day to calculate the next day
  date.setDate(date.getDate() + 1)

  return getLongDayAndMonth(date.toISOString())
})
</script>
